import { Siren } from "lucide-react";
import { LegalLayout } from "@/components/LegalLayout";
import { LegalSections } from "@/components/LegalSections";
import terms from "@/content/terms.mjs";

export default function Terms() {
  return (
    <LegalLayout
      title={terms.title}
      eyebrow={terms.eyebrow}
      updated={terms.updated}
      toc={terms.sections}
      testId="terms-page-container"
      backTestId="terms-back-home-button"
    >
      <div data-testid="terms-disclaimer-banner" className="not-prose mb-10 flex gap-4 rounded-2xl border border-rose-400/30 bg-rose-500/10 p-5">
        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-500/10 text-rose-300 border border-rose-400/30">
          <Siren size={18} strokeWidth={1.75} />
        </span>
        <div>
          <p className="font-display font-semibold text-rose-100">If you are experiencing a medical emergency, call 911 (or your local emergency number) immediately.</p>
          <p className="mt-1 text-sm text-rose-200/80 leading-relaxed">BeaconShield provides informational wait-time estimates and an AI assistant for general guidance only. It does not provide medical advice, diagnosis, triage decisions, or emergency dispatch.</p>
        </div>
      </div>
      <LegalSections sections={terms.sections} />
    </LegalLayout>
  );
}
